import * as React from 'react';

import {BrowserPreview} from 'shells/browser-preview/browser-preview';
import {FormField} from 'shells/form/form-field';
import {GreySection} from 'shells/layout/grey-section';
import {Stack} from 'shells/layout/stack/stack';
import {TextField} from 'shells/textfield/textfield';
import {MARKETING_AUTOMATIONS_TOUR_FOLLOW_UP_ID} from 'shells/tours/tours';
import {useNutshellTour} from 'shells/tours/use-nutshell-tour';
import {Body} from 'shells/typography/body';

import type {
    GetMoneyPage_maUrl_automation_actions as AutomationAction,
    GetMoneyPage_maUrl as MoneyPageMa,
} from 'nutshell-graphql-types';

import {CreateCardContainer} from './automation-cards/create-card-container';
import {NotificationCardContainer} from './automation-cards/notification-card-container';

import styles from './automation.module.css';

type Props = {
    moneyPage: MoneyPageMa;
};

export function Automation(props: Props) {
    const {moneyPage} = props;
    const {progressTour} = useNutshellTour();

    // Progress the tour when the page loads
    React.useEffect(() => {
        if (moneyPage) {
            const timer = setTimeout(() => {
                progressTour();
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [moneyPage, progressTour]);

    let actions: AutomationAction[] =
        moneyPage.automation && moneyPage.automation.actions ? moneyPage.automation.actions : [];

    const notificationAction: AutomationAction | null | undefined = actions.find(
        (action) => action.type === 'SEND_NOTIFICATION'
    );

    if (notificationAction) {
        actions = actions.filter((action) => action.id !== notificationAction.id);
    }

    return (
        <div
            id={MARKETING_AUTOMATIONS_TOUR_FOLLOW_UP_ID}
            className='flex full-width full-height pad-16 border-box gap-16'
        >
            <div className={styles['left-content']}>
                <Stack spacing={12}>
                    <FormField
                        innerId='money-page-url'
                        label={
                            <Body color='dark' isBold={true}>
                                URL
                            </Body>
                        }
                        noMargin={true}
                    >
                        <TextField
                            id='money-page-url'
                            value={moneyPage.url && moneyPage.url.fullyQualifiedUrl}
                            // @ts-expect-error
                            disabled={true}
                        />
                    </FormField>
                </Stack>
                <Stack spacing={4}>
                    <Body color='dark' isBold={true}>
                        What happens when a user lands on this page?
                    </Body>
                    <GreySection
                        content={
                            <CreateCardContainer
                                actions={actions}
                                urlId={moneyPage.id}
                                progressTour={progressTour}
                            />
                        }
                        noMargin={true}
                    />
                </Stack>
                <Stack spacing={4}>
                    <Body color='dark' isBold={true}>
                        Notifications
                    </Body>
                    <GreySection
                        content={
                            <NotificationCardContainer
                                notificationAction={notificationAction}
                                urlId={moneyPage.id}
                            />
                        }
                        noMargin={true}
                    />
                </Stack>
            </div>
            <Stack isFullWidth={true} spacing={8}>
                <BrowserPreview
                    src={moneyPage.url && moneyPage.url.fullyQualifiedUrl}
                    title={moneyPage.name}
                />
            </Stack>
        </div>
    );
}
